/* QF Growth Engine - Event Collector V0 (Shadow/Lab only)
   No network transmission. No PII. Events remain in memory for validation. */
(function () {
  'use strict';
  if (window.QFGrowth) return;
  var startedAt = Date.now();
  var events = [];
  function id(prefix) {
    try { return prefix + '_' + crypto.randomUUID(); }
    catch(e) { return prefix + '_' + Date.now().toString(36) + Math.random().toString(36).slice(2); }
  }
  var sessionId = id('qfs');
  function pageType() {
    var p = location.pathname;
    if (/^\/blogs\//.test(p)) return 'article';
    if (/^\/products\//.test(p) || /\/products\//.test(p)) return 'product';
    if (/^\/collections\//.test(p)) return 'collection';
    if (/^\/cart/.test(p)) return 'cart';
    if (p === '/') return 'home';
    return 'other';
  }
  function source() {
    var u = new URL(location.href), r = document.referrer;
    return {utm_source:u.searchParams.get('utm_source'),utm_medium:u.searchParams.get('utm_medium'),utm_campaign:u.searchParams.get('utm_campaign'),referrer:r||null};
  }
  function track(name, data) {
    var ev = {event:name,ts:new Date().toISOString(),session_id:sessionId,page_type:pageType(),path:location.pathname,source:source(),data:data||{}};
    events.push(ev);
    window.dispatchEvent(new CustomEvent('qf:growth:event',{detail:ev}));
    return ev;
  }
  window.QFGrowth = {version:'0.1.0-shadow',sessionId:sessionId,events:events,track:track};
  track('session_start',{landing_path:location.pathname});
  track('page_view',{title:document.title});
  var pt=pageType();
  if(pt==='article') track('article_view');
  if(pt==='product') track('product_view');
  if(pt==='collection') track('collection_view');
  if(pt==='cart') track('cart_view');
  document.addEventListener('click',function(e){
    var el=e.target.closest('a,button,[role="button"]'); if(!el)return;
    var txt=(el.innerText||el.getAttribute('aria-label')||'').trim().slice(0,120);
    var href=el.href||null;
    if(/comprar|adicionar|carrinho|checkout|finalizar/i.test(txt)) track('cta_click',{label:txt,href:href});
    if(/avalia|review/i.test(txt+(href||''))) track('review_interaction',{label:txt});
    if(/faq|dúvida|duvida|pergunta/i.test(txt+(href||''))) track('faq_interaction',{label:txt});
  },true);
  document.addEventListener('submit',function(e){
    var a=(e.target.getAttribute('action')||'');
    if(/\/cart\/add|\/cart\/change|\/cart\/update/.test(a)) track('cart_form_submit',{action:a});
  },true);
  window.addEventListener('pageshow',function(e){ if(e.persisted) track('page_restore'); });
})();